angular.module('bmsApp.marketing').controller('InitiativeSaveCtrl', function ($scope,
                                                                              $rootScope,
                                                                              $state,
                                                                              $log,
                                                                              ngTableParams,
                                                                              $state,
                                                                              $window,
                                                                              $q,
                                                                              $filter,
                                                                              InitiativeSvc,
                                                                              $timeout,
                                                                              CustomerGroupSvc,
                                                                              notify,
                                                                              $ngBootbox,
                                                                              CampaignSvc) {
    console.log($state.params);
    console.log('hit');

    $scope.loading = true;
    $scope.processing = false;
    $scope.updating = $state.is('main.marketing.campaignIndex.campaignOverview.initiativeUpdate');
    $scope.bulkCreate = $state.is('main.marketing.campaignIndex.initiativeCreate');
    $scope.formValidator = {};

    $scope.initiative = {
        campaign: {
            id: $state.params.campaignId
        },
        spend: []
    };
    $scope.campaign = {};
    $scope.campaigns = {
        selected: []
    }
    $scope.initiative_id = 1;

    $scope.initiativeDurationOptions = $scope.config.datePicker.range;

    var promises = [];
    promises.push(InitiativeSvc.names());
    promises.push(InitiativeSvc.statuses());
    promises.push(CustomerGroupSvc.index());

    if ($scope.updating) {
        promises.push(InitiativeSvc.read($state.params.initiativeId));
    }
    else {
        if ($state.is('main.marketing.campaignIndex.initiativeCreate')) {
            promises.push(CampaignSvc.index());
        }
        else {
            promises.push(CampaignSvc.read($scope.initiative.campaign.id));
        }
    }

    $q.all(promises).then(function (responses) {

        $timeout(function () {
            $scope.$apply(function () {
                $scope.initiativeNames = responses[0].data.options;
                $scope.statuses = responses[1].data.options;
                $scope.advertisingGroups = responses[2].data.customer_group_collection;

                if ($scope.updating) {
                    $scope.initiative = responses[3].data.initiative;
                    $scope.initiativeDateRange = {
                        startDate: $scope.initiative.start_date,
                        endDate: $scope.initiative.end_date
                    };
                    $scope.campaign.start_date = $scope.initiative.campaign.start_date;
                    $scope.campaign.end_date = $scope.initiative.campaign.end_date;
                    $scope.campaign.name = $scope.initiative.campaign.name; // for the breadcrumb
                }
                else {
                    if ($state.is('main.marketing.campaignIndex.initiativeCreate')) {
                        $scope.campaignOptions = responses[3].data.campaign_collection;
                        var cOptions = [];
                        angular.forEach($scope.campaignOptions, function(campaign) {
                            cOptions.push({
                                id: campaign.id,
                                value: campaign.name + ' - ' + campaign.license.license_number
                            });
                        });
                        $scope.campaignOptions = cOptions;
                    }
                    else {
                        $scope.campaign = responses[3].data.campaign;
                        angular.extend($scope.initiative, {
                            discount_codes: [],
                            spend: []
                        });
                    }
                }

                // Don't allow the user to specify a date outside of the campaign dates
                if (!$scope.bulkCreate) {
                    $scope.initiativeDurationOptions.options.minDate = moment($scope.campaign.start_date);
                    $scope.initiativeDurationOptions.options.maxDate = moment($scope.campaign.end_date);
                }
                $scope.initiativeDurationOptions.options.ranges = {};

            });
        }, 0);

        $scope.loading = false;

    });

    $scope.submit = function (initiative) {


        if ($scope.formValidator.valid()) {
            $scope.processing = true;

            initiative.start_date = $scope.initiativeDateRange.startDate;
            initiative.end_date = $scope.initiativeDateRange.endDate;

            // Find the initiative name from array
            angular.forEach($scope.initiativeNames, function (initiativeObject) {
                if (initiativeObject.id == initiative.initiative_id) {
                    initiative.name = initiativeObject.value;

                }
            });

            var submissionObject = null;
            if ($state.is('main.marketing.campaignIndex.initiativeCreate')) {
                submissionObject = {
                    campaigns: $scope.campaigns.selected,
                    initiative: initiative
                };
            }
            else {
                submissionObject = initiative;
            }

            var promise;
            promise = (initiative.id) ?
                InitiativeSvc.update(submissionObject) :
                InitiativeSvc.create(submissionObject);

            promise.then(function (response) {
                if ($state.is('main.marketing.campaignIndex.initiativeCreate')) {
                    notify({
                        message: 'Initiatives successfully saved'
                    });

                    $state.go('main.marketing.campaignIndex');
                }
                else {
                    notify({
                        message: initiative.id ? 'Initiative updated successfully' : 'Initiative created successfully'
                    });
                    $state.go('main.marketing.campaignIndex.campaignOverview', {id: initiative.campaign.id});
                }


            }, function (error) {
                $scope.errors = error;
            })
                .finally(function () {
                    $scope.processing = false;
                });
        }
    };

    $scope.setInitiativeName = function () {
        var initFilter = $filter('filter')($scope.initiativeNames, {
            id: $scope.initiative.initiative_id
        }, true);
        if (initFilter.length) {
            $scope.initiative.name = initFilter[0].value;
        }
    };

    $scope.addCode = function () {
        $scope.initiative.discount_codes.push({});
    };

    $scope.addSpend = function () {
        $scope.initiative.spend.push({});
    };

    $scope.removeSpendRow = function(spend) {
        $scope.initiative.spend.splice($scope.initiative.spend.indexOf(spend),1);
    }
    $scope.deleteInitiative=function(initiative){
       var initiative_id=initiative.id;
       $ngBootbox.customDialog({
                message: "Are you sure,You want to delete this initiative?",
                buttons: {
                    confirm: {
                        label: 'Yes Please',
                        className: 'btn-success',
                        callback: function() {
                           InitiativeSvc.delete(initiative,initiative_id).then((response) => {
                                notify({
                                    message: 'Initiative deleted successfully '
                                });
                                $state.go('main.marketing.campaignIndex.campaignOverview', {campaignId: initiative.campaign_id});
                            });
                        }
                    },
                    cancel: {
                        label: 'No Thanks',
                        className: 'btn-danger',
                        callback: function() {
                           
                        }
                    }
                },
                callback: function (result) {
                    console.log('This was logged in the callback: ' + result);
                }
            });
    }

});
